import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMemo } from "react";
import DvigubasGrafikas from "../BandosProduktyvumas/DvigubasGrafikas";

const LaktacijuGrafikoRodikliai = ({ isOpen, handleDialogClose, karve, laktacijuDuomenys }) => {
  const { chartData, raktaiLine, raktaiBar, yAxisMinLine, yAxisMaxLine, yAxisMinBar, yAxisMaxBar } =
    useMemo(() => {
      if (!laktacijuDuomenys || laktacijuDuomenys.length === 0) {
        return {
          chartData: [],
          raktaiLine: [],
          raktaiBar: [],
          yAxisMinLine: 0,
          yAxisMaxLine: 0,
          yAxisMinBar: 0,
          yAxisMaxBar: 0,
        };
      }

      const sortedData = [...laktacijuDuomenys].sort((a, b) => a.nr - b.nr);

      const transformedData = sortedData.map((item) => ({
        nr: item.nr, // Format x-axis label to show "Lakt. X"
        "Pieno kiekis kg": item.pienas_kg, // Line data
        "R+B kg": item.rb_kg, // Bar data
      }));

      const allPienas = sortedData.map((item) => item.pienas_kg).filter(Boolean);
      const allRB = sortedData.map((item) => item.rb_kg).filter(Boolean);

      const minPienas = allPienas.length ? Math.min(...allPienas) : 0;
      const maxPienas = allPienas.length ? Math.max(...allPienas) : 0;

      const minRB = allRB.length ? Math.min(...allRB) : 0;
      const maxRB = allRB.length ? Math.max(...allRB) : 0;

      const paddingPienas = (maxPienas - minPienas) * 0.1;
      const paddingRB = (maxRB - minRB) * 0.1;

      return {
        chartData: transformedData,
        raktaiLine: ["Pieno kiekis kg"], // Line data key
        raktaiBar: ["R+B kg"], // Bar data key
        yAxisMinLine: 0, //Math.max(0, minPienas - paddingPienas) / 4,
        yAxisMaxLine: maxPienas + paddingPienas,
        yAxisMinBar: 0, //Math.max(0, minRB - paddingRB) / 2,
        yAxisMaxBar: (maxRB + paddingRB) * 1.25,
      };
    }, [laktacijuDuomenys]);

  return (
    <Dialog open={isOpen} onClose={handleDialogClose} maxWidth="md" fullWidth closeAfterTransition>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6" sx={{ marginRight: 2 }}>
          Karvės {karve} produktyvumo kitimas per laktacijas
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DvigubasGrafikas
          pavadinimas="Laktacijų rodikliai per 264 d. laktaciją"
          isLoading={false}
          chartDataLine={chartData}
          chartDataBar={chartData}
          raktaiLine={raktaiLine}
          raktaiBar={raktaiBar}
          yAxisMinLine={Math.round(yAxisMinLine)}
          yAxisMaxLine={Math.round(yAxisMaxLine)}
          yAxisMinBar={Math.round(yAxisMinBar)}
          yAxisMaxBar={Math.round(yAxisMaxBar)}
          xAsis="nr"
          barHeight={400}
          kitokiaLegenda={false}
          asisApacioje="laktacijos"
          etikete
          barSize={50}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LaktacijuGrafikoRodikliai;
